<template>
  <div class="d-flex">
    <v-autocomplete
        :menu-props="{ bottom: true, offsetY: true }"
        class="rounded-lg"
        :items="items"
        v-model="item"
        :label="label"
        item-text="name"
        item-value="value"
        :disabled="disabled"
        :multiple="multiple"
        :clearable="clearable"
        :placeholder="placeholder"
        :return-object="false"
    ></v-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'PartnerSelect',
  props: {
    value: {},
    label: {
      default: null
    },
    placeholder: {
      default: null
    },
    disabled: {
      default: false
    },
    multiple: {
      default: false
    },
    clearable: {
      default: false
    }
  },
  data() {
    return {
      items: [],
      item: null
    };
  },
  computed: {
  },
  created() {
    this.getPartners();
  },
  mounted(){
    this.setItem();
  },
  methods: {
    getPartners() {
      this.request({
        url: this.endpoint(`partner-stock/partner/all`),
        method: "get",
        success: data => {
          this.items = []
          for (let partner of data) {
            this.items.push({
              'name': partner.name,
              'value': partner.id,
            })
          }
        }
      })
    },

    setItem() {
      if (this.value != this.item) this.item = this.value;
    }
  },
  watch: {
    value() {
      this.setItem();
    },
    item() {
      this.$emit("input", this.item);
    }
  }
};
</script>


<style lang="scss" scoped></style>
